module.exports = __webpack_public_path__ + "static/find_greater_steed-d389cc5d5c32c7ff1f43acd1229a4b4b.jpg";